export default __webpack_public_path__ + "static/media/notebook.d95053f0.png";